@if (guestUser) {
  <div class="welcome-card">
    <div class="header-card">
      <div class="header-side-part w-100">
        <div class="d-flex pe-2">
          <i class="ph-fill ph-user-circle"></i>
        </div>
        <div class="d-flex flex-column w-100 overflow-hidden">
          <span class="header-title">{{ 'welcome-panel.welcome-to-explain' | translate }}</span>
          <span
            class="header-subtitle text-limited-2-lines"
            [ngbTooltip]="guestUser.email"
            [openDelay]="500"
            placement="bottom"
            container="body"
            tooltipClass="simple-tooltip"
            >{{ guestUser.email }}</span
          >
        </div>
      </div>
    </div>
    <div class="body-card">
      <div class="collapse-block">
        <div class="collapse-title" (click)="collapse2.toggle()" [attr.aria-expanded]="!isCollapsed2">
          <span>{{ 'welcome-panel.what-is-explain-ask' | translate }}</span>
        </div>
        <div class="collapse-content" #collapse2="ngbCollapse" [(ngbCollapse)]="isCollapsed2">
          <span>{{ 'welcome-panel.what-is-explain-1' | translate }}</span>
          <br />
        </div>
      </div>
      <div class="fw-600 fs-s pt-2">
        <span>{{ 'welcome-panel.what-is-explain-2' | translate }} </span>
        <a class="href-underline" href="https://explain.fr" target="_blank" rel="noopener noreferrer">
          {{ 'welcome-panel.our-website' | translate }}</a
        >
        <span>&nbsp;{{ 'welcome-panel.what-is-explain-3' | translate }}</span>
      </div>
      <div class="contact-container pt-2 fw-600">
        <span>{{ 'welcome-panel.any-other-question' | translate }}</span>
        <a class="href-underline" href="mailto: info@explain.fr">
          {{ 'welcome-panel.contact-email' | translate }}
        </a>
      </div>
    </div>
  </div>
}
